import React from 'react';
import {
    Button,
    Dialog,
    Flex,
    DialogTitle,
    PriorityIcon
} from '@priority-software/priority-style-react';
import texts from '../../../features/MoreInfo/texts';

type Props = {
    isOpen: boolean;
    closeAlertDialog: () => void;
    exitWithoutSave: () => void;
};

export const AlertMessage = (props: Props) => {
    const {isOpen, closeAlertDialog, exitWithoutSave} = props;

    return (
        <Dialog
            isOpen={isOpen}
            zIndex={12500}
            onClose={closeAlertDialog}
            title={<DialogTitle icon={PriorityIcon.questionCircle} title={texts.exit_msg} />}
            footer={
                <Flex>
                    <Button skin="secondary" size="small" onClick={closeAlertDialog}>
                        {texts.exit_msg_no}
                    </Button>
                    <Button size="small" skin="primary" onClick={exitWithoutSave}>
                        {texts.exit_msg_yes}
                    </Button>
                </Flex>
            }
        />
    );
};
